import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  serviceId: null,

  // model
  serviceLinkedCmsModel: []
}

const getters = {
	get: state => state
}

const actions = {
	show ({commit}, {serviceId}) {
		// cover
		this.dispatch('core/showModalCover')

    commit('setServiceId', serviceId)
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
	},
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {serviceLinkedCmsParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceLinkedCms'],
        ['v1ServiceLinkedCmsListGet'],
        [serviceLinkedCmsParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setServiceLinkedCmsModel', res[0].data.serviceLinkedCmsSettings)
            console.log('serviceLinkedCmsModel', state.serviceLinkedCmsModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},
  setServiceId (state, id) {
    Vue.set(state, 'serviceId', id)
  },
  setServiceLinkedCmsModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'serviceLinkedCmsModel', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
